<template>
    <div :style="clockStyle" class="live-clock">
        <span :style="clockTextStyle" class="live-clock-text text-secondary">{{ clockDisplay }}</span>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                interval: null,
                clockDisplay: '',
                clockFormat: 'Full',
                clockStyle: null,
                clockTextStyle: null,
                showSeconds: false
            };
        },
        methods: {
            updateClock() {
                const now = new Date();

                const dayOfWeek = this.clockFormat.startsWith("FullDay") ? now.toLocaleDateString(undefined, { weekday: 'long' }) : '';
                const date = this.clockFormat.startsWith("Full") ? now.toLocaleDateString(undefined, { day: 'numeric' }) + this.ordinalSuffix(now.getDate()) : String(now.getDate()).padStart(2, '0');
                const month = this.clockFormat.startsWith("Full") ? now.toLocaleDateString(undefined, { month: 'long' }) : now.toLocaleDateString(undefined, { month: 'short' });
                const year = this.clockFormat === "FullDayYear" ? now.getFullYear() : '';
                const hour24 = now.getHours();
                const hour = this.clockFormat !== "Short" ? ((hour24 % 12) || 12) : hour24;
                const minute = String(now.getMinutes()).padStart(2, '0');
                const second = this.showSeconds ? ':' + String(now.getSeconds()).padStart(2, '0') : '';
                const ampm = this.clockFormat !== "Short" ? (hour24 >= 12 ? 'PM' : 'AM') : '';

                this.clockDisplay = `${dayOfWeek} ${date} ${month} ${year} ${hour}:${minute}${second} ${ampm}`.trim();
            },
            ordinalSuffix(day) {
                if (day > 3 && day < 21) return 'th';
                switch (day % 10) {
                    case 1: return 'st';
                    case 2: return 'nd';
                    case 3: return 'rd';
                    default: return 'th';
                }
            },
            setUpdateInterval() {
                clearInterval(this.interval);
                const intervalMs = this.showSeconds ? 1000 : 60 * 1000;
                this.updateClock();
                this.interval = setInterval(this.updateClock, intervalMs);
            }
        },
        created() {
            // Load theme & format
            if (this.$kmsTheme) {
                this.clockFormat = this.$kmsTheme.clockFormat || this.clockFormat;
                this.clockStyle = this.$kmsTheme.styles?.clock || null;
                this.clockTextStyle = this.$kmsTheme.styles?.clockText || null;
            }

            // Adapt format if on small screen
            if (this.clockFormat.startsWith("Full") && window.screen.height > window.screen.width)
                this.clockFormat = "Med";

            // Decide if we need to show seconds
            //this.showSeconds = !["Short"].includes(this.clockFormat);

            this.setUpdateInterval();
        },
        beforeDestroy() {
            clearInterval(this.interval);
        }
    };
</script>

<style>
    .live-clock {
        margin: 0.5rem;
        height: calc(80px - 1rem);
    }

    .live-clock-text {
        font-size: 60px;
    }

    .text-secondary {
        color: #6c757d !important;
    }

    @media only screen and (min-width: 1000px) and (orientation: portrait), only screen and (min-width: 1500px) and (orientation: landscape) {
        .live-clock-text {
            font-size: 65px;
        }
    }
</style>
